import { render, staticRenderFns } from "./vuelta_europa.vue?vue&type=template&id=668f80fc&"
import script from "./vuelta_europa.vue?vue&type=script&lang=js&"
export * from "./vuelta_europa.vue?vue&type=script&lang=js&"
import style0 from "./vuelta_europa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports